<template>
    <v-row no-gutters class="align-center">
        <v-col cols="2">
            <h4 class="pt-2 pl-4 pr-4">{{ $t('corporate.administration.history.registerDate') }} {{ item.date | momentFormatDate('L') }}</h4>
            <div class="pt-1 pl-4 pr-4 mb-4" v-if="isEmployee && !isHistory">
                <modal-board-members :loading="loading" :company-info="companyInfo" :current-board-members="item" :is-new="false" @close-board-success-dialog="refreshAll" :type="type"></modal-board-members>
                <v-btn
                    @click.native="deleteItem()"
                    class="mt-1"
                    color="error"
                >
                    <v-icon class="mr-1">mdi-delete</v-icon>
                    {{ $t('common.delete') }}
                </v-btn>
            </div>
        </v-col>
        <v-col cols="10">
            <h5 class="pt-2 pb-2 pl-4 pr-4">{{ $t('corporate.administration.history.admitted') }}</h5>
            <v-divider></v-divider>
            <v-data-table
                :headers="getHeaders(item)"
                :items="getCaptableFormated(membersNotDeprived)"
                :items-per-page="-1"
                hide-default-footer
            >
            </v-data-table>
            <template v-if="getCaptableFormatedDeprived(membersDeprived).length > 0">
                <v-divider></v-divider>
                <h5 class="pt-2 pb-2 pl-4 pr-4">{{ $t('corporate.administration.history.destitute') }}</h5>
                <v-divider></v-divider>
                <v-data-table
                    :headers="getHeadersDeprived(item)"
                    :items="getCaptableFormatedDeprived(membersDeprived)"
                    :items-per-page="-1"
                    hide-default-footer
                >
                </v-data-table>
            </template>
        </v-col>
    </v-row>
</template>

<script>
import API from '@/api'
import ModalBoardMembers from '@/components/corporate/ModalBoardMembers'

export default {
    name: 'datatable-board-members-read',
    props: ['type', 'companyInfo', 'item', 'isHistory'],
    components: {
        ModalBoardMembers
    },
    data: function () {
        return {
            loading: false
        }
    },
    computed: {
        isEmployee: function () {
            return this.$helpers.checkIsEmployee()
        },
        membersNotDeprived () {
            return this.item.members.filter((member) => {
                if (!member.deprivedStatus) return member
            })
        },
        membersDeprived () {
            return this.item.members.filter((member) => {
                if (member.deprivedStatus) return member
            })
        }
    },
    methods: {
        getHeaders (item) {
            let headerFormated = [
                { text: this.$t('corporate.administration.history.headers.name'), value: 'name', sortable: false },
                { text: this.$t('corporate.administration.history.headers.position'), value: 'position', align: 'center', sortable: false, currency: true },
                { text: this.$t('corporate.administration.history.headers.election'), value: 'election', align: 'center', sortable: false },
                { text: this.$t('corporate.administration.history.headers.mandate'), value: 'mandate', align: 'center', sortable: false }
            ]
            if (this.type !== 1) {
                headerFormated[0].text = this.$t('corporate.administration.history.headers.nameSA')
            }
            return headerFormated
        },
        getHeadersDeprived (item) {
            let headerFormated = [
                { text: this.$t('corporate.administration.history.headers.name'), value: 'name', sortable: false },
                { text: this.$t('corporate.administration.history.headers.position'), value: 'position', align: 'center', sortable: false, currency: true },
                { text: this.$t('corporate.administration.history.headers.deprived'), value: 'deprived', align: 'center', sortable: false }
            ]
            if (this.type !== 1) {
                headerFormated[0].text = this.$t('corporate.administration.history.headers.nameSA')
            }
            return headerFormated
        },
        getCaptableFormated (content) {
            let contentFormated = [...content]
            for (let index = 0; index < contentFormated.length; index++) {
                if (/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/.test(contentFormated[index].election)) {
                    contentFormated[index].election = this.$options.filters.momentFormatDateNoISO(contentFormated[index].election, 'L')
                }
                if (/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/.test(contentFormated[index].mandate)) {
                    contentFormated[index].mandate = this.$options.filters.momentFormatDateNoISO(contentFormated[index].mandate, 'L')
                }
                if (/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/.test(contentFormated[index].deprived)) {
                    contentFormated[index].deprived = this.$options.filters.momentFormatDateNoISO(contentFormated[index].deprived, 'L')
                }
            }
            return contentFormated
        },
        getCaptableFormatedDeprived (content) {
            let contentFormated = [...content]
            for (let index = 0; index < contentFormated.length; index++) {
                if (/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/.test(contentFormated[index].deprived)) {
                    contentFormated[index].deprived = this.$options.filters.momentFormatDateNoISO(contentFormated[index].deprived, 'L')
                }
            }
            return contentFormated
        },
        refreshAll () {
            this.$emit('refresh-all')
        },
        async deleteItem () {
            if (confirm(this.$t('corporate.administration.history.deleteConfirm'))) {
                let endpoint = API.EndPoints.deleteAdministration
                let params = {
                    objectId: this.item.objectId
                }
                let msg = this.$t('corporate.administration.history.deleteSuccess')
                await new API(endpoint, params).request()
                    .catch((error) => { msg = (error.status !== 0) ? error.data.error : this.$t('common.error') })
                alert(msg)
                this.refreshAll()
            }
        }
    }
}
</script>
